// The ONE Pay refund / Refund deposit button for every entry point (disabled with its reason, never hidden): label + enable rule come from refundAction.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { refundAction, refundSlots } from './refundAction.mjs';
import { formatMoneyExact } from '../../utils/format';
import { IcoChip } from '../../shell/ActionIcons';
import { useAuth } from '../../context/AuthContext';

export default function RefundButton({ snapshot, totals, onOpen, className = 'btn sm', style, row = false }) {
  const { t } = useTranslation('sales'); const { t: ti } = useTranslation('invoicing');
  const { isAdmin } = useAuth(), ra = refundAction(snapshot, totals, isAdmin);
  const why = ra.enabled ? '' : ti(ra.reason.key, { held: formatMoneyExact(ra.reason.held), owes: formatMoneyExact(ra.reason.owes) });
  const label = t(`orderDrawer.${ra.label}`), go = e => { e.stopPropagation(); if (ra.enabled) onOpen(); };
  // row = the shared row-action pattern (Sales Orders IcoChip, secondary 'Record' look: icon + text, 28px in these tables, same gap as .row-acts)
  if (row) {
    const slots = refundSlots(snapshot, totals, isAdmin);
    return <>{slots.map(s => { const l = t(`orderDrawer.${s.label}`); return <IcoChip key={s.label} className="sm" name="refund" label={l} aria={l} title={s.enabled ? l : why || l} disabled={!s.enabled} data-testid="refund-action" onClick={go} />; })}</>;
  }
  return <span title={why} data-testid="refund-action" style={ra.enabled ? undefined : { display: 'inline-flex' }}>
    <button type="button" className={className} style={style} disabled={!ra.enabled} aria-disabled={!ra.enabled} onClick={go}>{label}</button>
  </span>;
}
